export const DIRS = [1, -1];
